import z from "zod";

import {
  Button,
  SocialLinkSchema,
  WorkTimeList,
} from "@shared/content-types/schemas/common.schema";

export const LocationMapSchema = z.object({
  title: z.string().optional(),
  locationName: z.string(),
  description: z.string().optional(),
  coordinates: z.string(),
  email1: z.string().email().optional(),
  phone: z.string().optional(),
  email2: z.string().email().optional(),
  socialLinks: z.array(SocialLinkSchema),
  ctaButton: Button.base,
  onButtonClick: z.function(),
  workTimeList: z.array(WorkTimeList.dynamic).optional(),
});

export type LocationMapType = z.infer<typeof LocationMapSchema>;
